var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"row justify-content-center align-content-center align-items-center",staticStyle:{"min-height":"100%","flex-direction":"column"}},[_c('span',{staticClass:"text-color-blue",staticStyle:{"font-size":"7rem"}},[_vm._v("403")]),_vm._v(" "),_c('span',[_vm._v("Sin permisos")])])])])
}]

export { render, staticRenderFns }